module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"panel":"Панель","aboutCompany":"О компании","careerPortal":"Карьерный портал","vacancies":"Вакансии","qr":"QR codes","partnership":"Партнерам","candidates":"Кандидаты"}}')
  delete Component.options._Ctor
}
